import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminClavesSatCentrosCostoPage } from "@/features/admin-clave-sat-centro-costo/components/AdminClavesSatCentrosCostoPage";
import { clavesSatCentrosCostoQueryOptions } from "@/features/admin-clave-sat-centro-costo/hooks/use-clave-sat-centro-costo";

/**
 * Ruta `/admin/clave-sat-centro-costo` · gestor de la relación "clave producto/servicio SAT →
 * centro de costo por sociedad" (con el centro de costo automático del prorrateo FB60).
 * Paginado server-side (P42) · precarga la primera página.
 */
export const Route = createFileRoute("/_authed-tw/admin/clave-sat-centro-costo")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminClaveSatCentroCosto])
      ? queryClient.ensureQueryData(clavesSatCentrosCostoQueryOptions({ page: 1, pageSize: 15 }))
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminClaveSatCentroCosto]}>
      <AdminClavesSatCentrosCostoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
